export const terms_and_conditions = [
  {
    title: "Intellectual Property Rights",
    subContent: [
      {
        title: "Ownership",
        description: "All intellectual property rights, including but not limited to copyrights, trademarks, patents, trade secrets, and any other proprietary rights, in and to the Website and its contents are owned by the Company or its licensors. All rights are reserved.",
      },
      {
        title: "Limited License",
        description: "Subject to your compliance with these Terms, the Company grants you a limited, non-exclusive, non-transferable, revocable license to access and use the Website for your personal, non-commercial use. You may not reproduce, distribute, modify, create derivative works from, publicly display, or exploit any content from the Website without the prior written consent of the Company.",
      },
      {
        title: "Trademarks",
        description: "All trademarks, service marks, logos, and trade names displayed on the Website are the property of the Company or their respective owners. You may not use, reproduce, or display any trademarks without the prior written consent of the Company or the respective owners.",
      },
      {
        list: [],
        title: "",
      }
    ]
  },
  {
    title: "Restrictions",
    subContent: [
      {
        title: "Prohibited Use",
        description: "You are expressly prohibited from using the Website in any way that is unlawful, harmful, threatening, abusive, harassing, defamatory, libelous, invasive of another's privacy, or otherwise objectionable. You shall not engage in any conduct that could disable, overburden, or impair the proper functioning of the Website."
      },
      {
        title: "Compliance with Laws",
        description: "You must comply with all applicable laws, rules, and regulations in connection with your use of the Website."
      },
    ]
  },
  {
    title: "Application Programming",
    subContent: [
      {
        title: "Agreement",
        description: "For each application programming project, a separate agreement will be established. If no agreement has been formulated and/or no Terms of Use have been specified, the following delivery policy will apply."
      },
      {
        title: "Partial Refund",
        description: "If the project is not completed in accordance with the contract and delivery policy, the Company may provide the client with a partial refund based on the evaluation of the work completed."
      },
    ]
  },
  {
    title: "Applicability of the Delivery Policy",
    subContent: [
      {
        title: "Timely Payments",
        description: "Clients are required to make payments as agreed upon. Failure to do so may result in the project being considered null and void."
      },
      {
        title: "Client Responsibility",
        description: "It is the client's responsibility to provide Alchemis with regular and timely information to ensure the successful completion of the project. Alchemis will not be held responsible for any delays or failures caused by miscommunication or lack of communication on the client's part."
      },
      {
        title: "Completeness of Information",
        description: "Providing complete and accurate information and scope at the initial stages of the project is essential. Alchemis will not be obligated to fulfill any requests if the client fails to provide all the necessary information."
      },
      {
        title: "Compensation for Delays",
        description: "Unless a penalty clause is included in a special agreement between both parties, Alchemis will not provide compensation for any delays in project delivery."
      },
    ]
  },
  {
    title: "Governing Law and Jurisdiction",
    subContent: [
      {
        title: "Governing Law",
        description: "These Terms shall be governed by and construed in accordance with the laws of Singapore."
      },
      {
        title: "Jurisdiction",
        description: "Any disputes arising out of or in connection with these Terms or the use of the Website shall be subject to the exclusive jurisdiction of the courts of Singapore."
      },
    ]
  },
  {
    title: "Business Relationships",
    subContent: [
      {
        title: 'Third-Party Websites',
        description: "The Website may contain links to third-party websites. The Company is not responsible for the content of such websites and does not endorse or accept any responsibility for their content or use. Your use of third-party websites is at your own risk."
      },
    ]
  },
  {
    title: "Limitation of Liability",
    subContent: [
      {
        title: "Disclaimer",
        description: "The Company's obligations with respect to its products and services are governed solely by the agreements under which they are provided. Products or services obtained through the Website without an agreement are provided \"AS-IS\" with no warranties whatsoever, express or implied."
      },
      {
        title: "No Liability",
        description: "The Company shall not be liable to any party for any direct, indirect, special, or consequential damages arising from the use of the Website or any other hyperlinked website, including but not limited to lost profits, business interruption, or loss of data, even if the Company has been advised of the possibility of such damages."
      },
    ]
  },
  {
    title: "Indemnification ",
    subContent: [
      {
        title: "Indemnity",
        description: "You agree to indemnify and hold harmless the Company, its affiliates, officers, directors, employees, and agents from any and all liabilities, costs, demands, causes of action, damages, or expenses arising out of or in any way related to your breach of these Terms."
      },
    ]
  },
  {
    title: "Modifications",
    subContent: [
      {
        title: "Changes to Terms",
        description: "The Company may revise and update these Terms at any time without prior notice. Your continued use of the Website after any changes to the Terms constitutes your acceptance of the revised Terms."
      },
      {
        title: "Changes to Website",
        description: "The Company reserves the right to change, supplement, delete, or update any aspect of the Website without notice."
      },
    ]
  },
]
